
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curation/phoenix/[pageId]",
      function () {
        return require("private-next-pages/curation/phoenix/[pageId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curation/phoenix/[pageId]"])
      });
    }
  